import { render } from "./ShipmentList_item_group_icons.vue?vue&type=template&id=5e975f2a&scoped=true"
import script from "./ShipmentList_item_group_icons.vue?vue&type=script&lang=js"
export * from "./ShipmentList_item_group_icons.vue?vue&type=script&lang=js"

import "./ShipmentList_item_group_icons.vue?vue&type=style&index=0&id=5e975f2a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e975f2a"]])

export default __exports__